import { Box, Grid, Typography, Container } from "@mui/material";
import theme from "../theme/theme";

const Content1 = () => {
  return (
    <Container>
      <Grid container id="about">
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sx={{
            padding: "20px",
            fontFamily:'Emirates',


            height: {
              xs: "35vh",
              sm: "10vh",
              lg: "60vh",
            },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "2.5rem",
              fontWeight: 700,
              color: theme.palette.primary.main,
              textTransform: "uppercase",
            }}
          >
            Our Company
          </Typography>

          <Typography
            variant="body1"
            sx={{
              marginTop: "20px",
              fontSize: "1.2rem",
              lineHeight: 1.8,
              fontFamily:'Emirates',

              color: theme.palette.text.primary,
            }}
          >
            Taal Travel and Visa is a newly established company, led by a team
            of tourism industry experts with over 11 years of experience. We
            specialize in providing end-to-end visa assistance, offering a
            comprehensive range of travel services designed to simplify and
            streamline the visa application process for our clients.
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: {
              xs: "80vh",
              sm: "60vh",
              md: "80vh",
              lg: "60vh",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              overflow: "hidden",
            }}
          >
            <img
              src="/plane.webp"
              alt="Background"
              style={{
                position: "absolute",
                top: "50%",
                left: "40%",
                width: "350px",
                height: "350px",
                objectFit: "contain",
                zIndex: 99,
              }}
            />
            <img
              src="/Picture3.webp"
              alt="Background"
              style={{
                position: "absolute",
                top: "60%",
                left: "40%",
                width: "350px",
                height: "350px",
                objectFit: "contain",
                zIndex: 1,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Content1;
